module.exports = __webpack_public_path__ + "img/ເວບໄຊ-laodl-800x279.eea919da.jpg";